import { render, staticRenderFns } from "./PackagesDispatchModal.vue?vue&type=template&id=7dd54d08&scoped=true&"
import script from "./PackagesDispatchModal.vue?vue&type=script&lang=js&"
export * from "./PackagesDispatchModal.vue?vue&type=script&lang=js&"
import style0 from "./PackagesDispatchModal.vue?vue&type=style&index=0&id=7dd54d08&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dd54d08",
  null
  
)

export default component.exports